<form [formGroup]="productosForm" (ngSubmit)="onSubmit()">
    <table>
        <thead>
            <tr>
                <th *ngFor="let columna of columnas">{{ columna.nombre }}</th>
                <th>Producto</th>
                <th>Presentación</th>
            </tr>
        </thead>
        <tbody formArrayName="productos">
            <tr
                *ngFor="
                    let producto of productos.controls;
                    let productoIndex = index
                "
                [formGroupName]="productoIndex">
                <td *ngFor="let columna of columnas">
                    <ng-container *ngIf="columna.tipo === 'select'">
                        <select [formControlName]="columna.campo">
                            <option
                                *ngFor="let opcion of columna.opciones"
                                [value]="opcion">
                                {{ opcion }}
                            </option>
                        </select>
                    </ng-container>
                    <ng-container *ngIf="columna.tipo === 'selectService'">
                        <select [formControlName]="columna.campo">
                            <option
                                *ngFor="let option of columna.opciones"
                                [value]="option.id">
                                {{ option.nombre }}
                            </option>
                        </select>
                    </ng-container>
                    <ng-container
                        *ngIf="
                            columna.tipo !== 'select' &&
                            columna.tipo !== 'selectService'
                        ">
                        <input
                            *ngIf="!columna.mayusculas"
                            [formControlName]="columna.campo"
                            [type]="columna.tipo"
                            [placeholder]="columna.nombre"
                            [ngClass]="{
                                'error-field':
                                    erroresProductos[productoIndex]
                                        ?.codigoRepetidoProducto &&
                                    columna.campo === 'numeroRegistroIca',
                            }"
                            (blur)="
                                columna.campo === 'numeroRegistroIca'
                                    ? productoDuplicado($event, productoIndex)
                                    : null
                            " />
                        <app-input
                            *ngIf="columna.mayusculas"
                            [formControlName]="columna.campo"
                            [type]="columna.tipo"
                            [placeholder]="columna.nombre"
                            [requiredMayusculas]="columna.mayusculas"
                            [compact]="true">
                        </app-input>
                    </ng-container>
                </td>
                <td>
                    <button
                        type="button"
                        (click)="eliminarProducto(productoIndex)">
                        Eliminar
                    </button>
                </td>

                <td>
                    <table>
                        <thead>
                            <tr>
                                <th>Empaque</th>
                                <th>Unidad de medida equivalente</th>
                                <th>Cantidad</th>
                            </tr>
                        </thead>
                        <tbody formArrayName="presentaciones">
                            <tr
                                *ngFor="
                                    let presentacion of getPresentaciones(
                                        productoIndex
                                    ).controls;
                                    let presentacionIndex = index
                                "
                                [formGroupName]="presentacionIndex">
                                <td>
                                    <select
                                        formControlName="empaque"
                                        [ngClass]="{
                                            'error-field':
                                                presentacion.get(
                                                    'codigoPresentacion'
                                                )?.errors?.['codigoRepetido'],
                                        }"
                                        placeholder="Nombre de la presentación"
                                        (change)="
                                            onCambio(
                                                $event,
                                                productoIndex,
                                                presentacionIndex
                                            )
                                        ">
                                        <option
                                            value=""
                                            disabled
                                            selected
                                            class="grayed-text">
                                            Selecciona empaque
                                        </option>
                                        <option
                                            *ngFor="
                                                let option of empaquePresentaciones
                                            "
                                            [value]="option.id">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <select
                                        formControlName="empaqueUnidadMedidaId"
                                        (change)="
                                            onUnidadMedidaChange(
                                                $event,
                                                productoIndex,
                                                presentacionIndex
                                            )
                                        ">
                                        <option
                                            *ngFor="
                                                let option of presentacion.get(
                                                    'unidadesDeMedida'
                                                )?.value
                                            "
                                            [value]="
                                                option.EmpaqueUnidadMedida.id
                                            "
                                            [attr.data-codigo]="option.codigo">
                                            {{ option.nombre }}
                                        </option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        formControlName="cantidad"
                                        placeholder="Cantidad"
                                        type="number"
                                        min="0"
                                        max="99999.9"
                                        [value]="esNutricionAnimal ? 40 : ''"
                                        [readonly]="esNutricionAnimal"
                                        (keydown)="validacion($event)"
                                        maxlength="7"
                                        (change)="
                                            onCambio(
                                                $event,
                                                productoIndex,
                                                presentacionIndex
                                            )
                                        "
                                        [readonly]="
                                            !presentacion.get('empaque').value
                                        " />
                                </td>
                                <td>
                                    <button
                                        *ngIf="
                                            getPresentaciones(productoIndex)
                                                .length > 1
                                        "
                                        type="button"
                                        (click)="
                                            eliminarPresentacion(
                                                productoIndex,
                                                presentacionIndex
                                            )
                                        ">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <button
                        *ngIf="!esNutricionAnimal"
                        type="button"
                        (click)="agregarPresentacion(productoIndex)">
                        Agregar
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <button type="button" (click)="agregarProducto()">Agregar</button>
    <button type="submit" [disabled]="isFormInvalid">Guardar</button>
</form>
